import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader, Reveal } from "@/components/public/ui";
import { usePublic } from "@/hooks/usePublic";
import { mediaUrl } from "@/lib/media";

const fallback = [
  {
    id: "default",
    slug: "helmet-multigear-sanitization-station",
    name: "Helmet Multigear Sanitization Station",
    short_desc: "360° protection with UV + Heat + Air cleaning. Chemical-free, self-serve and AI-monitored.",
    image: "/aimway-logo.png",
  },
];

export default function Products() {
  const { data, loading } = usePublic("/products");
  const products = data && data.length ? data : fallback;

  return (
    <div data-testid="products-page">
      <PageHeader eyebrow="Products" title="Our helmet sanitization machines" subtitle="Purpose-built stations delivering fast, chemical-free, AI-verified hygiene for shared and personal gear." />
      <section className="container-page py-24">
        {loading ? (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {[0, 1, 2].map((i) => <div key={i} className="h-80 animate-pulse rounded-2xl bg-slate-100" />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {products.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.06}>
                <Link to={`/products/${p.slug || p.id}`} className="group block h-full overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-soft" data-testid={`product-card-${i}`}>
                  <div className="aspect-[4/3] overflow-hidden bg-brand-sky">
                    <img src={mediaUrl(p.image) || "/aimway-logo.png"} alt={p.name} className="h-full w-full object-contain p-6 transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <h3 className="font-display text-lg font-700 text-brand-navy">{p.name}</h3>
                    <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">{p.short_desc || p.description}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-700 text-brand-orange">View details <ArrowRight size={16} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
